import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import localStorageKey from "../enumerations/localStorageKey";
import { useGetUserInfo } from "../hooks/UserCenter/usercenter.hooks";
interface LoginContextType {
  isLogin: boolean;
  setIsLogin: (val: boolean) => void;
  checkIfLogin: () => void;
  checkIfVerified: () => any;
  setToken: (token: any) => void;
  checkLoginProcess: {
    process: () => boolean;
  };
}

const LoginContext = createContext<LoginContextType>({
  isLogin: false,
  setIsLogin: (val: boolean) => {},
  checkIfLogin: () => {},
  checkIfVerified: () => {},
  setToken: (token: any) => {},
  checkLoginProcess: {
    process: () => true,
  },
});

export const LoginContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const localToken = window.localStorage.getItem(localStorageKey.TOKEN);
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false);
  const { data: userInfo } = useGetUserInfo({ enabled: !!localToken });
  const [checkLoginProcess, setLocalCheckLoginProcess] = useState({
    process: () => true,
  });

  // const { mutate: logout } = useLogout();

  const setCheckLoginProcess = (newFunc: any) => {
    setLocalCheckLoginProcess({ process: newFunc });
  };

  const checkIfVerified = () => {
    if (userInfo?.status === 0) {
      return false;
    }
    return true;
  };

  const checkIfLogin = () => {
    if (!isLogin) {
      navigate("/signin");
      return false;
    } else {
      return checkIfVerified();
    }
  };

  const setToken = (token: any) => {
    localStorage.setItem(localStorageKey.TOKEN, JSON.stringify(token));
  };

  useEffect(() => {
    const userIsLogin = Boolean(
      window.localStorage.getItem(localStorageKey.USER_ACCOUNT)
    );
    setIsLogin(userIsLogin);
  }, []);

  useEffect(() => {
    setCheckLoginProcess(checkIfLogin);
  }, [userInfo, isLogin]);

  return (
    <LoginContext.Provider
      value={{
        isLogin,
        setIsLogin,
        checkIfLogin,
        checkIfVerified,
        setToken,
        checkLoginProcess,
      }}
    >
      {children}
      {/* NEED LOGIN MODAL */}
      {/* <CustomModal
        isModalVisible={showNeedLoginModal}
        setIsModalVisible={setShowNeedLoginModal}
        title={t("normal.notLoggedIn")}
        content={t("normal.notLoggedIn.hint")}
        needIcon={true}
        okBtnText={t("normal.forwardTo")}
        cancelBtnText={t("normal.cancel")}
        onOk={() => {
          setShowNeedLoginModal(false);
          if (isHaveInvitation === true) {
            navigate(`/signup?invite=${agentCode}`);
          } else {
            navigate("/signin");
          }
        }}
      /> */}
    </LoginContext.Provider>
  );
};
export const useLogin = () => {
  const LoginValue = useContext(LoginContext);
  return LoginValue;
};
